import {useEffect,useState} from 'react';
import {cartToken,post} from './api';
import {useStore} from './store';
import {normalizeCoupon} from './coupon';
import type {Quote} from './types';
export function useCartQuote(deliveryMethod:string,location:{department?:string;city?:string}={}){
 const {cart,coupon,setCoupon}=useStore();
 const [applying,setApplying]=useState(false);
 const key=JSON.stringify([cart,deliveryMethod,coupon,location.department||'',location.city||'']);
 const [result,setResult]=useState<{key:string;value?:Quote;error?:string}>({key:''});
 useEffect(()=>{let current=true;if(!cart.length){setResult({key});return;}void post<Quote>('/cart/quote',{token:cartToken(),deliveryMethod,coupon,...location}).then(value=>{if(current)setResult({key,value})}).catch(e=>{if(current)setResult({key,error:e.message})});return()=>{current=false}},[key]);
 const quote=result.key===key?result.value:null;
 const error=result.key===key?result.error||'':'';
 async function apply(raw:string){const code=normalizeCoupon(raw);if(!code)throw Error('Escribe tu código de descuento.');setApplying(true);try{await post<Quote>('/cart/quote',{token:cartToken(),deliveryMethod,coupon:code,...location});setCoupon(code)}finally{setApplying(false)}}
 return {quote,error,pending:applying||(cart.length>0&&result.key!==key),coupon,apply,removeCoupon:()=>setCoupon('')};
}
